export const ASSET_TYPES = [
  {
    name: "Chromebook",
    id: "Chromebook",
    show: false,
    label: "Chromebook",
  },
  {
    name: "Desktop",
    id: "Desktop",
    show: false,
    label: "Desktop",
  },
  {
    name: "Game Console",
    id: "Game Console",
    show: false,
    label: "Game Console",
  },
  {
    name: "iPad",
    id: "iPad",
    show: false,
    label: "iPad",
  },
  {
    name: "Laptop",
    id: "Laptop",
    show: false,
    label: "Laptop",
  },
  {
    name: "MacBook",
    id: "MacBook",
    show: false,
    label: "MacBook",
  },
  {
    name: "Phone",
    id: "Phone",
    show: false,
    label: "Phone",
  },
  {
    name: "Smart Watch",
    id: "Smart Watch",
    show: false,
    label: "Smart Watch",
  },
  {
    name: "Tablet",
    id: "Tablet",
    show: false,
    label: "Tablet",
  },
];
